<script setup lang="ts">
import { useRouter } from 'vue-router';
import { Finanzmanager } from "@/application/router/types/types";
import BankingWrapper from '@/application/layouts/ContentWrapper/BankingWrapper.vue';
import { throwableCall } from '@/api/lib/integration.ts';
import { deleteBanksApiUser } from '@/api/banking/banksApi.ts';
import { useBankingStore } from '@/banking/store/bankingStore.ts';
import { captureException } from '@sentry/vue';
import { useTagManager } from '@demv_systems/feu-tag-manager';
import { TrackEventCategory } from '@/application/utils/tracking/events';
import AppButton from '@/application/components/ui/AppButton.vue';

const router = useRouter();
const bankingStore = useBankingStore();

async function onOpenRegprotect(e: CustomEvent) {
  const { sessionLink } = e.detail;
  await router.push({ path: '/banking/regprotect', query: { sessionLink } });
}

async function onGoBack(event: CustomEvent) {
  event.preventDefault();
  await router.push('/banking');
}

async function onDeleteUser() {
  try {
    await throwableCall(deleteBanksApiUser())
    useTagManager().push({ event: TrackEventCategory.BANKS_API, action: 'deleteUser' });
  } catch (err) {
    captureException(err);
  } finally {
    bankingStore.$reset();
    await router.push({ name: Finanzmanager.VERTRAEGE });
  }
}
</script>

<template>
  <BankingWrapper v-slot="{ token, onEmitError }">
    <!-- eslint-disable vue/v-on-event-hyphenation -->
    <!-- eslint-disable vue/attribute-hyphenation -->
    <ba-bam-dashboard
      :token="token"
      @openRegprotect="onOpenRegprotect"
      @goBack="onGoBack"
      @emitError="(e) => onEmitError(e, 'ba-bam-dashboard')"
    >
      <div slot="custom-element" class="flex justify-center">
        <AppButton
          type="danger"
          plain
          class="w-full sm:max-w-[480px]"
          @click="onDeleteUser"
        >
          Multibanking-Konto löschen
        </AppButton>
      </div>
    </ba-bam-dashboard>
  </BankingWrapper>
</template>
